import {createContext} from 'react';

export const StationsContext = createContext({stations: [], loading: true, error: false});
